// @flow
import React from 'react';
import access from 'safe-access';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit'

import ControlWrapper from '../controls/ControlWrapper';

import Select from 'react-select';

import DatePickerWrapper from '../controls/DatePickerWrapper';

import ReactSelectSimple from '../controls/ReactSelectSimple';

import * as projectApi from '../../api/project';
import { getSegments } from '../../api/segment'


const selectProjectKey = (state, props) => props.params.projectKey;
const selectProject = (state, props) => state.projects[selectProjectKey(state, props)];

const getTargets = createSelector(
  selectProject,
  project => project.targets
);

const getRulesForm = createSelector(
  (state, props) => props.baseModel,
  (state)=>state.form.rules,
  (baseModel, rulesForm)=> access(rulesForm, baseModel)
)

const getSelectedTarget = createSelector(
  getRulesForm,
  rulesForm => {
    return access(rulesForm, 'target')
  }
);

const getTarget = createSelector(
  getTargets,
  getSelectedTarget,
  (targets, key) => targets.filter(target=>target.key === key)[0]
);


const getOperator = createSelector(
  getRulesForm,
  condition => access(condition, 'operator')
);

const getValues = createSelector(
  getRulesForm,
  condition => access(condition, 'values')
)

const getRulesFormMeta = createSelector(
  (state, props) => props.baseModel,
  (state)=>state.form.forms.rules,
  (baseModel, rulesFormMeta)=> access(rulesFormMeta, baseModel)
)

const hasErrors = createSelector(
  getRulesFormMeta,
  conditionMeta => !access(conditionMeta,'values.$form.valid')
)

const ValueSelector = ({ target, operator, values, projectKey, hasErrors }) => {
  const commonProps = {
    model: ".values[0]",
    validateOn: ['blur', 'change'],
    disabled: !target || !operator
  };

  const loadSegmentOptions = async (searchQuery) => {
    const response = await getSegments(projectKey, environmentKey, target, searchQuery);
    return { options: response.json() };
  };

  const loadTargetValues = async (input) => {
    try {
      const options = await projectApi.getTargetValues(projectKey, access(target, 'key'), input);
      return {
        options: options.map(option => ({
          label: option,
          value: option
        }))
      };
    } catch (err) {
      return { options: [] };
    }
  };

  if (!target) return null;

  switch (target.type) {
    case 'date':
      return (
        <ControlWrapper
          {...commonProps}
          errorMessages={{ isRequired: 'Required' }}
          placeholder="Date"
          component={DatePickerWrapper}
          getValue={(value) => {
            return value?.toISOString() || value || ''
          }}
        />
      );
    case 'segment':
      return (
        <ReactSelectSimple
          key={`segment-${target.key}`}
          model=".values"
          component={Select.AsyncCreatable}
          placeholder="Segments"
          {...commonProps}
          multi
          errorMessages={{ isRequiredArray: 'Segment is required' }}
          loadOptions={loadSegmentOptions}
        />
      );
    case 'string': {
      const multi = ['in', 'notIn', 'segment'].includes(operator);
      console.log("isMulti: ", multi);
      return (
        <ReactSelectSimple
          key={`string-${target.key}`}
          model=".values"
          disabled={commonProps.disabled}
          component={Select.AsyncCreatable}
          placeholder={multi ? 'Values' : 'Value'}
          multi={multi}
          errorMessages={{ isRequiredArray: 'Value is required' }}
          loadOptions={loadTargetValues}
        />
      );
    }
    case 'number':
      return (
        <ControlWrapper
          {...commonProps}
          placeholder="Number"
          type="number"
          parser={val => Number.parseFloat(val)}
          errorMessages={{ isRequiredNumber: 'Required' }}
        />
      );
    default:
      return (
        <ControlWrapper
          {...commonProps}
          placeholder="Value"
          errorMessages={{ isRequired: 'Required' }}
        />
      );
  }
};

const mapStateToProps = (state, props) => ({
  target: getTarget(state, props),
  operator: getOperator(state, props),
  values: getValues(state, props),
  projectKey: props.params.projectKey,
  hasErrors: hasErrors(state, props)
});

export default withRouter(connect(mapStateToProps)(ValueSelector));
